import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BclientsURL, CREDIT_URL, PORTEFEUILLE_URL } from "../../settings/APISetting";
import { arrayFilter, output } from "../../settings/themeSettings";
import axiosInstance from "../../config/axiosConfig";






export const fetchClients = createAsyncThunk("fetch-clients", async (params = { page: 1, nail: null }) => {
    try {
        console.log('[clientStore] fetchClients appelé avec params:', params);
        const orderBy = 'id'; // Tri par ID
        const order = 'desc'; // Ordre décroissant

        let url = `${BclientsURL}?isarchived=0&page=${params.page}&orderBy[${orderBy}]=${order}`;

        if (params.nail) {
            url += `&search=${params.nail}`;
        }

        console.log('[clientStore] URL de requête:', url);
        const response = await axiosInstance.get(url);
        console.log('[clientStore] Réponse reçue:', response);
        console.log('[clientStore] Données clients:', response.data);
        console.log('[clientStore] Nombre de clients:', Array.isArray(response.data) ? response.data.length : 'Non-array');
        return response.data;
    } catch (error) {
        console.error("[clientStore] Erreur lors de la récupération des clients:", error);
        console.error("[clientStore] Détails de l'erreur:", error.response?.data || error.message);
        throw error;
    }
});


export const creditAccount = (infos, err, cb) => {
    axiosInstance.post(CREDIT_URL, infos)
        .then((response) => {
            output(response);
            cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}


export const fetchClient = (id, err, cb) => {
    axiosInstance.get(`${PORTEFEUILLE_URL}/${id}`)
        .then((response) => {
            output(response);
            cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
};
export const editClient = (id, client, err, cb) => {
    axiosInstance.put(`${PORTEFEUILLE_URL}/${id}`, client, {
        headers: { 'Content-Type': 'application/ld+json' }
    })
        .then((response) => {
            output(response);
            cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
};


export const createClient = (client, err, cb) => {
    axiosInstance.post(PORTEFEUILLE_URL, client, {
        headers: { 'Content-Type': 'application/ld+json' }
    })
        .then((response) => {
            output(response);
            cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

const clientSlice = createSlice({
    name: 'clients',
    initialState: { clients: [], fetchStatus: '', currentClient: {} },
    reducers: {
        addClient: (state, action) => {
            state.clients = [action.payload, ...state.clients];
        },
        filterClients: (state, action) => {
            state.clients = arrayFilter(new RegExp(action.payload.nail), state.clients);


        }

    },

    extraReducers: (builder) => {
        builder.addCase(fetchClients.fulfilled, (state, action) => {
            // if(action.payload.length <= 0){
            //     state.fetchStatus = 'last_item';
            //     return state;
            // }
            state.clients = [...action.payload]; // Les données sont déjà triées par le serveur
            output(action.payload);
            state.fetchStatus = 'success';
        }).addCase(fetchClients.pending, (state, action) => {
            // state.clients[]
            state.fetchStatus = 'loading';

        }).addCase(fetchClients.rejected, (state, action) => {
            // state.clients[]
            output(action);

            state.fetchStatus = 'error';

        });
    }
});

export default clientSlice;